"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BulbOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<rect x="11" y="25" width="10" height="2" rx="1"/><rect x="12" y="28" width="8" height="2" rx="1"/><path d="M16 4a7.6 7.6 0 017.8 7.5 7.2 7.2 0 01-3.8 6.4l-1 .5V22h-6v-3.6l-1-.5a7.3 7.3 0 01-3.8-6.4A7.8 7.8 0 0116.1 4m0-2a9.8 9.8 0 00-9.9 9.5 9.3 9.3 0 004.8 8.1V23a1 1 0 001 1h8a1 1 0 001-1v-3.4a9.2 9.2 0 004.8-8.1A9.6 9.6 0 0016 2z"/>';
var BulbOutlineSVG = function BulbOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.BulbOutlineSVG = BulbOutlineSVG;
BulbOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(BulbOutlineSVG);
exports.default = _default;